<template>
  <el-tabs
    :style="{
      marginLeft: '15px',
    }"
    ref="main"
    :value="value"
    :before-leave="tabClick"
  >
    <el-tab-pane
      class="l-tabs-container"
      :label="$t('常规查询')"
      name="ordinary"
    >
      <div
        ref="parentContainer"
        class="l-query"
        :style="{
          height: `${myHeight}px`,
          overflowY: rowNum >= 5 && isOpened ? 'auto' : 'none',
        }"
      >
        <el-form :model="formData" size="mini" ref="form">
          <input type="text" style="display: none" />

          <template v-for="(item, index) in displayedItems">
            <!-- 高代码 -->
            <el-col
              class="item"
              :style="{
                width: !item.width ? itemWidth + 'px' : item.width + 'px',
              }"
              v-if="item.comptype == 'code'"
              :key="index"
            >
              <el-form-item
                :label-width="
                  item.labelWidth ? item.labelWidth + 'px' : '100px'
                "
                :label="$t(item.label)"
                :ref="item.prop"
                :prop="item.prop"
              >
                <slot :name="item.prop"></slot>
              </el-form-item>
            </el-col>
            <el-col
              :style="{ width: item.width + 'px' }"
              v-if="item.comptype == 'cus'"
              :span="item.span || span"
              :key="index"
            >
              <el-form-item
                :label-width="
                  item.labelWidth ? item.labelWidth + 'px' : '100px'
                "
                :label="$t(item.label)"
                :ref="item.prop"
                :prop="item.prop"
              >
                <dragFormItem :data="item"></dragFormItem>
              </el-form-item>
            </el-col>

            <!-- CUSTOM -->
            <el-col
              :style="{ width: item.width + 'px' }"
              v-if="item.comptype == 'def'"
              :span="item.span || span"
              :key="index"
            >
              <el-form-item
                :label-width="
                  item.labelWidth ? item.labelWidth + 'px' : '100px'
                "
                :label="$t(item.label)"
                :ref="item.prop"
                :prop="item.prop"
              >
                <dragFormItem :data="item"></dragFormItem>
              </el-form-item>
            </el-col>
          </template>
        </el-form>
      </div>
      <div class="l-query-btns">
        <el-button @click="handleResetClick" size="mini">{{
          $t("重置")
        }}</el-button>

        <el-button
          @click="handleSearchClick"
          size="mini"
          type="primary"
          :loading="loading"
          >{{ $t("查询") }}</el-button
        >
        <el-button
          @click="hanleOpenClick"
          size="mini"
          type="text"
          :icon="this.isOpened ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >{{ this.isOpened ? $t("收起") : $t("展开") }}</el-button
        >
      </div>
    </el-tab-pane>

    <el-tab-pane
      style="position: relative; overflow: hidden"
      :label="$t('高级查询')"
      name="complex"
    >
      <div
        class="l-query"
        :style="{
          height:
            8 + (complexV ? (complexEm >= 25 ? 25 : complexEm) : 0) + 'em',
          position: 'relative',
          overflow: 'hidden',
        }"
      >
        <!-- {{ columnsToRules(columns) }} -->
        <l-complex-query
          @close="closeComplexQuery"
          @queryChange="handleQueryChange"
          :size="'100%'"
          ref="complexquery"
          :customItems="customItems"
          :rules="columnsToRules(config.columns)"
          @complexQuery="handleComplexQuery"
          @saveExpression="handleSaveExpression"
        ></l-complex-query>
        <div class="l-query-btns">
          <l-fullscreen-dialog
            @ok="handleQueryMetaConfigOk"
            :modal="true"
            title="查询表单项配置"
            :visible.sync="configVisible"
          >
            <Form
              :customItems="customItems"
              ref="configForm"
              :config="config"
            ></Form>
          </l-fullscreen-dialog>

          <el-button
            v-if="
              !loginInfo
                ? true
                : loginInfo.roleNames.split(',').includes('系统管理员')
            "
            size="mini"
            @click="configVisible = true"
            icon="el-icon-setting"
            >配置组件
          </el-button>
          <el-button @click="handleResetClick" size="mini">{{
            $t("重置")
          }}</el-button>

          <el-button
            @click="handleComplexSearchClick"
            size="mini"
            type="primary"
            :loading="loading"
            >{{ $t("查询") }}</el-button
          >
          <el-button
            @click="hanleOpenComplexClick"
            v-if="rowNum > 1"
            size="mini"
            type="text"
            :icon="
              this.complexpIsOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
            "
            >{{ this.complexpIsOpen ? $t("收起") : $t("展开") }}</el-button
          >
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import ResizeDetector from "element-resize-detector";
import Form from "./Form";
import dragFormItem from "./components/formDesign/_src/dragFormItem.vue";
import api from "./api";
export default {
  name: "l-query",
  props: {
    value: {
      Type: String,
      default: "ordinary",
    },

    config: {
      Type: Object,
      default: () => {
        return {
          schemeCode: "test",
          columns: [],
        };
      },
    },
    // 设计编码
    schemeCode: {
      Type: String,
      default: "test",
    },

    complexHeight: {
      Type: Number,
      default: 100,
    },

    labelWidth: {
      type: Number,
      default: 88,
    },
    span: {
      type: Number,
      default: 6,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    height: Number,
    formData: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isResetSearch: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Form,
    dragFormItem,
  },
  data() {
    return {
      formDataCopy: {},
      parentWidth: null,
      itemWidth: 275,
      resizeDetector: null,
      customItems: [],
      itemsData: this.$deepClone(this.items),
      itemsDataCopy: this.$deepClone(this.items),
      dbTableData: [],
      configVisible: false,
      queryDATA: {},
      complexEm: 0,
      complexVisible: false,
      itemMaps: {},
      targetColumns: [],
      complexpIsOpen: false,
      isOpened: false,
      myHeight: 40,
      fist: true,
      btnWidth: 0,
      formDataInit: this.$deepClone(this.formData),
    };
  },
  provide() {
    return {
      customItems: this.customItems,
      formDesign: "",
      formData: this.formData, // 假设 formDesignData 是父组件中的某个数据或对象
    };
  },

  beforeDestroy() {
    this.destroyResizeDetector(); // 销毁 ResizeDetector
  },
  async mounted() {
    this.initResizeDetector(); // 初始化 ResizeDetector

    api.defaults.headers.common["token"] = this.token
      ? this.token
      : "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3MjQ3MjM0NjUsImV4cCI6MTcyNDgxMzQ2NSwiVXNlcklkIjoiU3lzdGVtIiwiVXNlck5hbWUiOiLotoXnuqfnrqHnkIblkZgiLCJBY2NvdW50Ijoic3lzdGVtIn0.u920uqKsvfT6N-ay2A3QdhKGj5N3lEg85Ir962lIoWY";
    this.loadQueryScheme();
    this.$emit("update:height", this.myHeight);
  },
  computed: {
    myitems() {
      if (this.isOpened || this.rowNum == 1) {
        return this.itemsData;
      } else {
        const list = [];

        this.itemsData.forEach((item) => {
          list.push(item);
        });

        return list;
      }
    },

    displayedItems() {
      // 根据父元素宽度计算显示的元素数量，并返回相应数量的项
      const itemsPerRow = Math.floor(this.parentWidth / this.itemWidth);
      if (this.isOpened) {
        return this.myitems;
      }
      console.log(this.myitems);

      return this.myitems.slice(0, itemsPerRow);
    },

    rowNum() {
      let span = 0;
      let row = 0;
      this.itemsData.forEach((item) => {
        if (span + (item.span || this.span) > 24) {
          row += 1;
          span = 0;
        }
        span += item.span || this.span;
      });

      if (span > 0) {
        row += 1;
      }
      return row;
    },
  },
  methods: {
    initResizeDetector() {
      this.resizeDetector = new ResizeDetector();
      this.resizeDetector.listenTo(this.$refs.parentContainer, () => {
        this.updateParentWidth();
      });
    },
    destroyResizeDetector() {
      this.resizeDetector.uninstall(this.$refs.parentContainer);
      this.resizeDetector = null;
    },
    updateParentWidth() {
      // 获取并更新父元素的宽度
      this.parentWidth = this.$refs.parentContainer.offsetWidth - 200;
      // 根据新的父元素宽度重新计算单个元素宽度
      this.calculateItemWidth();
    },
    calculateItemWidth() {
      // 逻辑可以根据需求调整，例如保持固定数量的元素或者动态调整元素宽度
      // 这里仅作示例，假设我们希望保持每行显示固定数量的元素，且元素宽度一致
      if (this.parentWidth && this.itemMaps >= 250) {
        this.itemWidth = Math.floor(
          this.parentWidth / Math.ceil(this.myitems.length + 1 / 2)
        );
      }
    },

    isCodeComponent() {},
    isCustomComponent(item) {
      // 正则表达式用于匹配 "数字_数字" 的格式
      const regex = /^\d+_\d+$/;
      let isCodeComponent = false;
      // 遍历 columns 数组
      for (let i of this.itemsDataCopy) {
        if (i.prop === item.field) {
          isCodeComponent = true;
        }
      }
      return regex.test(item.prop) && !isCodeComponent;
    },

    async loadQueryScheme() {
      let res = null;/* await api
        .get(`/queryScheme/${this.config.schemeCode}`)
        .then((res) => res.data.data)
        .catch((err) => {
          console.log(err);
        }); */
      console.log("res",res);
      
      this.itemsDataCopy.forEach((obj) => {
        obj.comptype = "code";
        obj.field = obj.prop;
      });

      if (!res) {
        //无配置分支
        this.itemsData = [
          ...this.itemsDataCopy,

          //默认值
          // ...this.convertToComponents(this.config.columns, []),
        ];
        this.itemsData = this.filterAndPrioritizeFields(this.itemsData);

        this.customItems = this.convertToComponents(this.config.columns, []);

        return;
      }
      let components = JSON.parse(res.scheme).formInfo.tabList[0].components;
      components.forEach((item) => {
        item.comptype = "cus";
      });
      this.itemsData = [
        ...this.itemsDataCopy,

        //配置
        ...components.filter((item) => item.used.includes("routine")),
        //默认值

        ...this.convertToComponents(this.config.columns, components).filter(
          (item) => item.used.includes("routine")
        ),
      ];

      this.itemsData = this.filterAndPrioritizeFields(this.itemsData);

      this.customItems = components.filter((item) =>
        item.used.includes("advanced")
      );
    },

    countFields(obj) {
      return Object.keys(obj).length;
    },

    filterAndPrioritizeFields(data) {
      // 创建一个 Map 用于存储每个 field 的最高优先级对象
      const fieldPriorityMap = new Map();

      data.forEach((item) => {
        // 获取当前 item 的 field 和 comptype
        const field = item.field.toLowerCase();
        const comptype = item.comptype;
        if (item.dataType == "datetime") {
        }

        // 检查是否已经存在这个 field 的记录
        if (!fieldPriorityMap.has(field)) {
          // 如果不存在则直接添加
          fieldPriorityMap.set(field, item);
        } else {
          // 如果存在则比较优先级
          const existingItem = fieldPriorityMap.get(field);
          const existingComptype = existingItem.comptype;

          // 比较优先级并更新
          if (
            ["cus", "code", "def"].indexOf(comptype) <
            ["cus", "code", "def"].indexOf(existingComptype)
          ) {
            fieldPriorityMap.set(field, item);
          }
        }
      });

      // 将 Map 转换为数组并返回
      return Array.from(fieldPriorityMap.values());
    },
    // 示例数据

    isValidFormat(str) {
      // 正则表达式匹配数字 + 下划线 + 数字的格式
      return /^\d+_\d+$/.test(str);
    },
    convertToComponents(columns, existingComponents) {
      const existingFields = new Set(
        existingComponents.map((component) => component.field)
      );

      const components = columns
        .filter((column) => !column.isNotCus)
        .map((column) => {
          let componentConfig = {
            width: 275,
            id: column.prop,
            type: "input",
            label: column.label,
            span: 6,
            display: true,
            default: "",
            placeholder: "请输入",
            prop: column.prop,
            table: "table",
            used: ["advanced"],
            field: column.prop,
            comptype: "def",
            csType: column.dataType,
          };

          switch (column.dataType) {
            case "number":
              componentConfig.type = "number";
              break;
            case "datetime":
              componentConfig.dateType = "datetime";
              componentConfig.type = "datetime";
              break;
            case "input":
              componentConfig.type = "input";
              break;
            default:
              componentConfig.type = "input";
              break;
          }

          return componentConfig;
        })
        .filter((component) => !existingFields.has(component.field));

      return components;
    },
    async handleQueryMetaConfigOk() {
      if (!this.$refs.configForm.validate()) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "保存中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0)",
      });

      let postData = this.$refs.configForm.getForm(false);
      if (postData.query_Scheme_Id != null) {
        await api.put(`/queryScheme`, postData);
        setTimeout(() => {
          loading.close();
        }, 500);
        this.dialogTableVisible = false;
        this.configVisible = false;
        this.loadQueryScheme();
        return;
      }

      await api.post(`/queryScheme`, postData);

      setTimeout(() => {
        loading.close();
      }, 500);
      this.dialogTableVisible = false;
      this.configVisible = false;
      this.loadQueryScheme();
    },

    handleComplexSearchClick() {
      this.$refs.complexquery.handleQuery();
    },
    closeComplexQuery() {
      this.$emit("input", "ordinary");
    },
    handleQueryChange(val) {
      this.$emit(
        "update:complexHeight",
        100 + val.rules * 55 + val.groups * 55
      );
      this.complexpIsOpen = true;
      this.queryDATA = val;
      this.complexEm = val.rules * 3.4 + val.groups * 2;
    },
    complexV() {
      return this.value == "complex";
    },
    tabClick(value) {
      if (value != "complex") {
        if (Object.keys(this.formDataCopy).length > 0) {
          for (let prop in Object.keys(this.formData)) {
            this.formData[Object.keys(this.formData)[prop]] =
              this.formDataCopy[Object.keys(this.formData)[prop]];
          }
        }
      }

      if (this.complexpIsOpen) {
        this.hanleOpenComplexClick();
      }
      if (this.isOpened) {
        this.hanleOpenClick();
      }

      this.$emit("update:height", 44);
      this.$emit("input", value);
    },
    hanleOpenComplexClick() {
      this.complexpIsOpen = !this.complexpIsOpen;
      if (!this.complexpIsOpen) {
        this.complexEm = 0;
        this.$emit("update:complexHeight", 60);
      }
      if (this.complexpIsOpen) {
        this.$emit(
          "update:complexHeight",
          80 + this.queryDATA.rules * 55 + this.queryDATA.groups * 55
        );
        this.complexEm = this.queryDATA.rules * 3.5 + this.queryDATA.groups * 2;
      }
    },
    handleComplexQuery(query) {
      this.formDataCopy = this.$deepClone(this.formData);

      for (let prop in Object.keys(this.formData)) {
        this.formData[Object.keys(this.formData)[prop]] = null;
      }

      this.formData.complexQueryString = encodeURIComponent(query);

      this.$emit("update:formData", this.formData);
      this.$emit("search", this.$deepClone(this.formData));

      this.formData.complexQueryString = encodeURIComponent(query);
    },

    handleSaveExpression(query) {
      this.formData.complexQueryString = query;
    },
    columnsToRules(columns) {
      let arr = [];
      this.$deepClone(columns)
        .filter((item) => !item.isNotCus)
        .forEach((item) => {
          let obj = {
            id: item.prop,
            label: item.label,
            type: this.getType(item.dataType),
          };
          if (obj.type === "dataItem" || obj.type === "dataSource") {
            obj.dataCode = item.dataCode;
          }

          if (obj.type === "dataSource") {
            obj.labelKey = item.labelKey;
            obj.valueKey = item.valueKey;
            obj.columns = item.columns;
          }

          arr.push(obj);
        });

      return arr;
    },

    getType(sType) {
      switch (sType) {
        case "input":
          return "text";

        case "datetime":
          return sType;
        case "date":
          return sType;
        case "number":
          return "numeric";
        case "dataSource":
          return sType;
        case "dataItem":
          return sType;
        default:
          return "text";
      }
    },
    hanleOpenClick() {
      this.isOpened = !this.isOpened;

      if (this.isOpened) {
        this.myHeight = this.rowNum * 20 + 12 + 28 + 40;
        if (this.rowNum > 4) {
          this.myHeight = 4 * 30 + 12 + 28 + 40;
        }
      } else {
        this.myHeight = 40;
      }
      this.$emit("update:height", this.myHeight);
    },
    handleResetClick() {
      for (var id in this.formDataInit) {
        this.$set(this.formData, id, this.formDataInit[id]);
      }
      if (this.isResetSearch) {
        this.$nextTick(() => {
          this.handleSearchClick();
        });
      }
    },
    handleSearchClick() {
      this.formData.complexQueryString = null;

      this.$emit("update:formData", this.$deepClone(this.formData));
      this.$emit("search", this.$deepClone(this.formData));
    },
  },
};
</script>
<style lang="less">
.el-range-editor.el-input,
.el-range-editor.el-input__inner {
  // padding: 0
}
@import "./index.less";
</style>
